var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 45,
    viewBox: "0 0 47 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5357 24.0363C45.3839 24.0363 46.0714 23.3487 46.0714 22.5006C46.0714 21.6524 45.3839 20.9648 44.5357 20.9648C43.6876 20.9648 43 21.6524 43 22.5006C43 23.3487 43.6876 24.0363 44.5357 24.0363Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53571 24.0363C2.38387 24.0363 3.07143 23.3487 3.07143 22.5006C3.07143 21.6524 2.38387 20.9648 1.53571 20.9648C0.687563 20.9648 0 21.6524 0 22.5006C0 23.3487 0.687563 24.0363 1.53571 24.0363Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53516 1L44.5352 44",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6437 22.4997C27.6437 19.955 25.5813 17.8926 23.0366 17.8926C21.249 17.8926 19.7164 18.9215 18.9531 20.4081L25.1282 26.5832C26.6148 25.8199 27.6437 24.2873 27.6437 22.4997Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5103 15.9683C16.4761 13.4083 19.5582 11.7497 23.0351 11.7497C28.9722 11.7497 33.7851 16.5627 33.7851 22.4997C33.7851 25.9766 32.1265 29.0588 29.5665 31.0245L33.7621 35.22C41.8522 31.0368 45.8205 23.3351 45.8205 23.3351L45.7683 21.5906C45.7683 21.5906 36.8565 7.14258 23.0351 7.14258C17.9887 7.14258 13.6058 9.07604 10.0645 11.5209L14.5103 15.9683Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7703 32.57C25.6046 33.0031 24.35 33.2503 23.0354 33.2503C17.0983 33.2503 12.2854 28.4374 12.2854 22.5003C12.2854 21.1858 12.5326 19.9311 12.9657 18.7655L7.603 13.4043C2.96207 17.3081 0.302215 21.5912 0.302215 21.5912L0.25 23.3358C0.248465 23.3358 7.67825 37.8575 23.0354 37.8575C25.8765 37.8575 28.4426 37.3553 30.7447 36.546L26.7703 32.57Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/Hide.ba541d4fb3b41fa715fd2052168665a8.svg";
export { ForwardRef as ReactComponent };